export const SPACE_TYPE_COLORS = {
  STARTUP: {
    gradient: 'linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)',
    bgLight: 'rgba(59, 130, 246, 0.1)',
    bgMedium: 'linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(96, 165, 250, 0.2) 100%)',
    color: '#3b82f6',
    hoverShadow: '0 8px 20px rgba(59, 130, 246, 0.3)',
  },
  INVESTOR: {
    gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
    bgLight: 'rgba(16, 185, 129, 0.1)',
    bgMedium: 'linear-gradient(135deg, rgba(16, 185, 129, 0.15) 0%, rgba(52, 211, 153, 0.2) 100%)',
    color: '#10b981',
    hoverShadow: '0 8px 20px rgba(16, 185, 129, 0.3)',
  },
  INNOVATE: {
    gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
    bgLight: 'rgba(245, 158, 11, 0.1)',
    bgMedium: 'linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(251, 191, 36, 0.2) 100%)',
    color: '#f59e0b',
    hoverShadow: '0 8px 20px rgba(245, 158, 11, 0.3)',
  },
} as const;

export type SpaceType = keyof typeof SPACE_TYPE_COLORS;
